import { arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { AuthenticationCredentialUsage } from "./types";

export const isAuthenticationCredentialUsagesResult = arrayOf(
  objectOf({
    surface: enumOf<AuthenticationCredentialUsage["surface"]>("campaign", "canvas", "template"),
    id: string,
    name: string,
  })
);
